import React, { useState } from 'react';
import { forEach, set } from 'lodash';
import styled from 'styled-components/macro';
import { DataGrid } from '@material-ui/data-grid';
import { white } from 'variables/colors';
import AdditionalTableActions from './AdditionalTableActions';

const Component = styled.div`
  flex-grow: 1;

  .MuiDataGrid-root {
    position: relative;
    background-color: ${white};
  }

  .MuiDataGrid-window {
    overflow-y: ${({ statusMenuOpen }) =>
      statusMenuOpen && 'hidden !important'};
  }
`;

const DataTable = ({
  rows,
  columns,
  handleModalOpen,
  setPageNumber,
  setPageSize,
  pageNumber,
  pageSize,
  rowCount,
  loading,
  setRowSelected,
  toggleMenu,
  disableCheckbox,
  enableCopy,
  fetchClinics,
  statusMenuOpen,
}) => {
  const [selectedRows, setSelectedRows] = useState([]);

  const formatPhoneNumber = (phoneNumberString) => {
    const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return null;
  };

  forEach(rows, (row) => {
    set(row, 'phone', formatPhoneNumber(row.phone));
    set(row, 'contact_phone', formatPhoneNumber(row.contact_phone));
  });

  const onCellClick = (params, event) => {
    const { field, id } = params;
    const { target } = event;

    if (field === 'status') {
      setRowSelected({ params, target });
      toggleMenu();
    } else {
      handleModalOpen({ id });
    }
  };

  return (
    <Component
      style={{ height: 400, width: '100%' }}
      statusMenuOpen={statusMenuOpen}
    >
      <DataGrid
        loading={loading}
        rows={rows}
        columns={columns}
        components={{
          Toolbar: () => (
            <AdditionalTableActions
              selectedRows={selectedRows}
              enableCopy={enableCopy}
              fetchClinics={fetchClinics}
            />
          ),
        }}
        checkboxSelection={!disableCheckbox}
        filterModel={{
          items: [
            {
              columnField: 'name',
              operatorValue: 'contains',
            },
          ],
        }}
        onPageChange={(newPage) => setPageNumber(newPage)}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        disableSelectionOnClick
        page={pageNumber}
        pageSize={pageSize}
        rowCount={rowCount}
        paginationMode="server"
        onCellClick={onCellClick}
        onSelectionModelChange={(newSelection) => {
          setSelectedRows(newSelection);
        }}
        pagination
      />
    </Component>
  );
};

export default DataTable;
